import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';
import { Label, Input } from 'reactstrap';
import uuid from 'uuid/v4';
import classNames from 'classnames';
import { useRadioGroup } from './RadioGroup';
import FormGroup from './FormGroup';

var Radio = function Radio(_ref) {
  var label = _ref.label,
      id = _ref.id,
      checkValue = _ref.value,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, ["label", "id", "value", "className", "children"]);

  var _useRadioGroup = useRadioGroup(checkValue),
      value = _useRadioGroup.value,
      setValue = _useRadioGroup.setValue,
      metadata = _useRadioGroup.metadata,
      inline = _useRadioGroup.inline;

  var _useState = useState(id || uuid()),
      inputId = _useState[0];

  var classes = classNames(className, metadata.touched ? 'is-touched' : 'is-untouched', metadata.touched && metadata.error && 'is-invalid');
  return React.createElement(FormGroup, {
    "for": inputId,
    check: true,
    inline: inline,
    disabled: attributes.disabled
  }, React.createElement(Input, Object.assign({
    id: inputId,
    name: inputId,
    className: classes,
    type: "radio"
  }, attributes, {
    value: checkValue,
    checked: value,
    onChange: setValue
  })), React.createElement(Label, {
    check: true,
    "for": inputId
  }, label || children));
};

export default Radio;